import { Chip, Tooltip, Typography } from "@mui/material"
import { differenceInDays, format, startOfDay } from "date-fns"


interface CardStatusProps {
    date: Date;
    title: string;
    tooltip: string;
}


export const CardStatus = ({ date, title, tooltip }: CardStatusProps) => {

    const daysSince = differenceInDays(startOfDay(date), startOfDay(new Date()));

    if (date < new Date()) {
        return (
            <Tooltip title={tooltip}>
                <Chip
                    color="error"
                    size="small"
                    label={
                        <Typography variant="caption">
                            {title}: {`${format(date, 'MMM dd')} (${daysSince * -1} day${daysSince === -1 ? '' : 's'} ago)`}
                        </Typography>
                    } />
            </Tooltip>
        );
    }

    return (
        <Chip
            color="info"
            size="small"
            label={
                <Typography variant="caption">
                    {title}: {`${format(date, 'MMM dd')} (in ${daysSince} day${daysSince === 1 ? '' : 's'})`}
                </Typography>
            } />
    )

}